import { render, staticRenderFns } from "./InvestmentOpportunities.vue?vue&type=template&id=3accdc96&scoped=true"
import script from "./InvestmentOpportunities.vue?vue&type=script&lang=js"
export * from "./InvestmentOpportunities.vue?vue&type=script&lang=js"
import style0 from "./InvestmentOpportunities.vue?vue&type=style&index=0&id=3accdc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3accdc96",
  null
  
)

export default component.exports